import { render, staticRenderFns } from "./BotSocialPlatformsListCard.vue?vue&type=template&id=f50aab9c"
import script from "./BotSocialPlatformsListCard.vue?vue&type=script&lang=ts"
export * from "./BotSocialPlatformsListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports